import React from 'react';
import { Button, type buttonPresets } from '@/components/UI/Button';
import { useTranslationContext } from '@/context/translation';
import { useTranslationWithLocale } from '@/hooks/useTranslationWithLocale';
import { GenerateLandingLinkService } from '@/services/generateLandingLinkService';
import { GoogleService } from '@/services/googleService';
import { appButtons } from '@/data/footerData';
import { GOOGLE_EVENTS } from '@/constants/googleEvents';
import styles from './ButtonGroup.module.scss';

interface Props {
	preset: buttonPresets | undefined;
	classes?: {
		blockClass?: string;
		buttonClass?: string;
		iconClass?: string;
	};
}

export const ButtonGroup: React.FC<Props> = ({ preset, classes }) => {
	const { blockClass, buttonClass, iconClass } = classes ?? {};
	const { locale, translations } = useTranslationContext();
	const { t } = useTranslationWithLocale(
		'sharedLandingData',
		locale,
		translations?.sharedLandingData as Record<string, unknown> | undefined,
	);

	const handleAppButtonClick = () => {
		GoogleService.logEvent(GOOGLE_EVENTS.LANDING_PASSED);
		window.location.href = GenerateLandingLinkService.webApp();
	};

	return (
		<div className={`${styles['group__apps']} ${blockClass}`}>
			{appButtons.map(btn => {
				const href = GenerateLandingLinkService.webApp();
				const ariaLabel = t('buttons.openWebApp') || 'Open web app';

				return (
					<Button
						key={btn.type}
						classes={{
							button: `
							${styles['group__app-button']}
							${styles[`group__app-button-${btn.type}`]}
							${buttonClass}`,
							icon: `
							${styles['group__action-icon']}
							${styles[`group__app-icon-${btn.type}`]}
							${iconClass}`,
						}}
						as='link'
						href={href}
						target='_blank'
						rel='noopener noreferrer'
						aria-label={ariaLabel}
						rounded
						type='button'
						Icon={btn.Icon}
						iconPosition='left'
						preset={preset}
						onClick={handleAppButtonClick}
					/>
				);
			})}
		</div>
	);
};
